module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "center",
    staticStyle: {
      "line-height": "2em"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "big1"
  }, [_vm._v("WELCOME TO THE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/tp_everuthing.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "big2"
  }, [_vm._v("PARENT’S GUIDE TO")])])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Everything"), _c('sup', [_vm._v("®")]), _vm._v(" Parent’s Guides are a part of the bestselling Everything"), _c('sup', [_vm._v("®")]), _vm._v(" series and cover common parenting issues like childhood illnesses and tantrums, as well as medical conditions like asthma and juvenile diabetes. These family-friendly books are designed to be a one-stop guide for parents. If you want authoritative information on specific topics not fully covered in other books, Everything"), _c('sup', [_vm._v("®")]), _vm._v(" Parent’s Guides are your perfect solution.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/alert.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Urgent warnings")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/essen.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Quick handy tips")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/fact.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Important snippets of information")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/que.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Answers to common questions")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("When you’re done reading, you can finally say you know "), _c('strong', [_vm._v("EVERYTHING")]), _c('sup', [_vm._v("®")]), _vm._v("!"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PUBLISHER")])]), _vm._v(" Karen Cooper")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("DIRECTOR OF ACQUISITIONS AND INNOVATION")])]), _vm._v(" Paula Munier")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MANAGING EDITOR, EVERYTHING"), _c('sup', [_vm._v("®")]), _vm._v(" SERIES")])]), _vm._v(" Lisa Laing")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("COPY CHIEF")])]), _vm._v(" Casey Ebert")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("ASSISTANT PRODUCTION EDITOR")])]), _vm._v(" Melanie Cordova")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACQUISITIONS EDITOR")])]), _vm._v(" Brett Palana-Shanahan")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SENIOR DEVELOPMENT EDITOR")])]), _vm._v(" Brett Palana-Shanahan")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDITORIAL ASSISTANT")])]), _vm._v(" Ross Weisman")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("EVERYTHING"), _c('sup', [_vm._v("®")]), _vm._v(" SERIES COVER DESIGNER")])]), _vm._v(" Erin Alexander")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("LAYOUT DESIGNERS")])]), _vm._v(" Erin Dawson, Michelle Roy Kelly, "), _c('br'), _vm._v("Elisabeth Lariviere, Denise Wallace")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Visit the entire Everything"), _c('sup', [_vm._v("®")]), _vm._v(" series at "), _c('em', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "http://www.everything.com",
      "target": "_blank"
    }
  }, [_vm._v("www.everything.com")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-492d98e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/fm1.vue
// module id = 66
// module chunks = 0